module.exports = __webpack_public_path__ + "img/20.0e94bc50.png";